import { render, staticRenderFns } from "./EditTaskQueue.vue?vue&type=template&id=646a24e2&"
import script from "./EditTaskQueue.vue?vue&type=script&lang=js&"
export * from "./EditTaskQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports